import React from 'react';

const PlayButton = () => {
  return (
    <svg width="67" height="65" viewBox="0 0 67 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.41 11.7C9.13476 11.7 4.01999 16.6621 4.01999 22.75V42.25C4.01999 48.3378 9.13476 53.2999 15.41 53.2999H51.59C57.8652 53.2999 62.98 48.3378 62.98 42.25V22.75C62.98 16.6621 57.8652 11.7 51.59 11.7H15.41V11.7ZM15.41 15.6H51.59C55.7077 15.6 58.96 18.7552 58.96 22.75V42.25C58.96 46.2447 55.7077 49.3999 51.59 49.3999H15.41C11.2923 49.3999 8.03999 46.2447 8.03999 42.25V22.75C8.03999 18.7552 11.2923 15.6 15.41 15.6V15.6ZM28.81 24.05V40.95L43.55 32.5L28.81 24.05Z" fill="#1A1A1A" />
    </svg>
  );
};

export default PlayButton;
